<template>
  <div class="page">
    <img v-for="img in imgList" v-lazy="img" :key="img" />
  </div>
</template>

<script>
  import { cdnresources } from '@/util/config'
  export default {
    data() {
      return {
        cdnresources,
        imgList: [
          cdnresources + '/prod/images/hunan2021/JKSC_2021_01.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_02.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_03.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_04.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_05.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_06.png',
          cdnresources + '/prod/images/hunan2021/JKSC_2021_07.png',
        ]
      }
    },
    components: {}
  }
</script>

<style lang="scss" scoped>
  img {
    width: 100%;
    height: 100%;
  }
</style>
